<div class="w-form">
  <form *ngIf="activityForm" [formGroup]="activityForm" id="email-form" name="email-form" data-name="Email Form">
    <h4 class="heading-20">
      Select the type of pin that applies to this location
      <span class="fine-print trinidad">(Required)</span>
    </h4>
    <p class="wizard-paragraph">Please select any category to this location.</p>
    <div class="poi-pin-outer">
      <div class="poi-pin-inner">
        <a
          title="Off-site Activities"
          data-w-id="63aca1a8-701e-251c-8872-d2afd8cb2c72"
          [ngClass]="{ selected: selected.activity }"
          (click)="toggleActivities()"
          class="poi-icon-activities w-inline-block"
        >
          <div class="w-embed">
            <curbnturf-category-svg icon="activity" [white]="selected.activity"> </curbnturf-category-svg>
          </div>
        </a>
        <div
          [ngClass]="{ selected: selected.dump }"
          (click)="toggleDump()"
          title="Sanidump"
          class="poi-icon-dump-station"
        >
          <div class="w-embed">
            <curbnturf-category-svg icon="dump" [white]="selected.dump"> </curbnturf-category-svg>
          </div>
        </div>
        <div
          [ngClass]="{ selected: selected.restArea }"
          (click)="toggleRestArea()"
          title="Rest Stop"
          class="poi-icon-rest-stops"
        >
          <div class="w-embed">
            <curbnturf-category-svg icon="restArea" [white]="selected.restArea"> </curbnturf-category-svg>
          </div>
        </div>
        <div [ngClass]="{ selected: selected.wifi }" (click)="toggleWifi()" title="Wifi" class="poi-icon-wifi">
          <div class="w-embed">
            <curbnturf-category-svg icon="wifi" [white]="selected.wifi"> </curbnturf-category-svg>
          </div>
        </div>
        <div
          [ngClass]="{
            selected: selected.potableWater,
            arg: !selected.potableWater
          }"
          (click)="togglePotableWater()"
          title="Fresh Water"
          class="poi-icon-fresh-water"
        >
          <div class="w-embed">
            <curbnturf-category-svg icon="potableWater" [white]="selected.potableWater"> </curbnturf-category-svg>
          </div>
        </div>
        <div [ngClass]="{ selected: selected.propane }" (click)="togglePropane()" title="Propane" class="poi-icon-lpg">
          <div class="w-embed">
            <curbnturf-category-svg icon="propane" [white]="selected.propane"> </curbnturf-category-svg>
          </div>
        </div>
      </div>
      <div class="offsite-poi-inner" [ngClass]="{ opened: activityOpened(), closed: !activityOpened() }">
        <div>Select any off-site activities that apply to this location.</div>
        <div class="offsite-activities-poi-inner">
          <ng-container *ngFor="let activity of activityTypes | enumSelector">
            <label
              *ngIf="activity.key !== 'custom'"
              class="cnt-button categories"
              [ngClass]="{ active: activityControl(activity.key)?.value }"
              [title]="activity.key === 'ohv' ? 'OHV stands for Off-Highway Vehicle' : ''"
            >
              <input
                type="checkbox"
                [formControl]="activityControl(activity.key)"
                (change)="activityChanged(activity.key)"
              />
              <div *ngIf="activity.key !== activity.value" class="cnt-button-icon">
                <div class="html-embed w-embed">
                  <curbnturf-site-svgs [type]="activity.key" [white]="activityControl(activity.key)?.value">
                  </curbnturf-site-svgs>
                </div>
              </div>
              <div class="cnt-button-copy">{{ activity.value }}</div>
            </label>
          </ng-container>

          <div class="custom-activity-row">
            <input
              type="text"
              class="custom-name w-input"
              placeholder="Unlisted Activity"
              [formControl]="activityForm?.controls.customActivity"
            />
            <div class="trash-icon">
              <curbnturf-misc-svg icon="trash" (click)="activityForm?.controls.customActivity?.setValue('')">
              </curbnturf-misc-svg>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="error" class="alert-danger">
        {{ error }}
      </div>
    </div>

    <div class="horz-line _18px"></div>
    <h4>
      Confirm the pin location
      <span class="fine-print trinidad">(Required)</span>
    </h4>
    <curbnturf-location-optional
      [addressForm]="activityForm?.controls.address"
      [coordinatesForm]="activityForm?.controls.coordinates"
      [coordinatesShow]="true"
    >
    </curbnturf-location-optional>

    <div class="horz-line _18px"></div>
    <h4>
      <label for="locationName">Name your location</label>
      <span class="fine-print trinidad">(Optional)</span>
    </h4>
    <input
      [formControl]="activityForm?.controls.name"
      id="locationName"
      type="text"
      class="text-input w-input"
      maxlength="256"
      placeholder="Type name of location here..."
    />

    <h4>
      <label for="locationDescription">Location description</label>
      <span class="fine-print trinidad">(Optional)</span>
    </h4>
    <textarea
      id="locationDescription"
      [formControl]="activityForm?.controls.description"
      placeholder="Type a description the site and what is located on or near this location..."
      maxlength="5000"
      class="site-description w-input"
    ></textarea>

    <div class="categories-description-outer">
      <a (click)="showDescription = !showDescription" class="link-block w-inline-block">
        <h5>Expand to enter contact info...</h5>
      </a>
      <div [ngClass]="{ closed: !showDescription }" class="categories-categories-inner">
        <h4>
          <label for="resourceUrl">Resource URL</label>
          <span class="fine-print trinidad">(Optional)</span>
        </h4>
        <input
          id="resourceUrl"
          [formControl]="activityForm?.controls.url"
          type="text"
          maxlength="256"
          placeholder="Type a website that provides additional information..."
          class="text-input w-input"
        />
        <h4>
          <label for="phoneNumber">Phone Number</label>
          <span class="fine-print trinidad">(Optional)</span>
        </h4>
        <input
          id="phoneNumber"
          cntMaskPhone
          [formControl]="activityForm?.controls.phone"
          type="tel"
          maxlength="256"
          placeholder="Type phone number here..."
          class="text-input w-input"
        />
      </div>
    </div>

    <div class="horz-line _18px"></div>
    <h4>Upload photos <span class="fine-print trinidad">(Recommended)</span></h4>
    <curbnturf-activity-photos [activityForm]="activityForm" [activity]="activityObject"> </curbnturf-activity-photos>

    <div class="horz-line"></div>

    <div *ngIf="error" id="add-activity-form-error" class="alert-danger">
      {{ error }}
    </div>

    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-label>Show</ion-label>
        <ion-toggle
          color="orange"
          [checked]="!activityForm.get('hidden')?.value"
          (ionChange)="setShowValue($event?.detail?.checked)"
          aria-label="Show"
        >
        </ion-toggle>

        <ng-container *ngIf="admin">
          [
          <ion-label>Approve</ion-label>
          <ion-toggle color="success" [formControl]="activityForm?.controls.available" aria-label="Approve"> </ion-toggle>
          ]
        </ng-container>
      </ion-buttons>
      <ion-buttons slot="end">
        <a *ngIf="activityObject?.id" (click)="closeModal()" class="previous-button w-inline-block">
          <span class="cnt-button">
            <span class="cnt-button-copy">Cancel</span>
          </span>
        </a>
        <a (click)="save()" class="next-button w-inline-block">
          <span class="cnt-button">
            <span class="cnt-button-copy">Save</span>
          </span>
        </a>
      </ion-buttons>
    </ion-toolbar>

    <div class="close-x">
      <a data-w-id="1686c13c-f378-cb71-5cff-1dcd1dfb1299" (click)="closeModal()" class="close-x-svg"> </a>
    </div>
  </form>
</div>
